import ApplicationInput from "~/components/application/input";

const ApplicationAboutYouSocials = () => {
  return (
    <div>
      <p>Profils en ligne</p>
      <p>
        Vous pouvez ajouter vos profils en ligne pour nous en dire plus à propos
        de vous.
      </p>
      <p>Instagram</p>
      <ApplicationInput
        register="instagram"
        placeholder="@nomdutilisateur"
        label="instagram"
        size={12}
      />
      <p>Linkedin</p>
      <ApplicationInput
        register="linkedin"
        placeholder="https://linkedin.com/yourprofile"
        label="linkedin"
        size={25}
      />
      <p>Site Internet</p>
      <ApplicationInput
        register="website"
        placeholder="https://yourwebsite.com"
        label="website"
        size={19}
      />
    </div>
  );
};

export default ApplicationAboutYouSocials;
